import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Flex, Box } from 'grid-styled'
import classNames from 'classnames'
import { getSharesDilution } from '../../api/otc/company/company'
import styles from './CompanyQuoteSecurity.module.scss'
import Locale from '../../components/Locale'
import Loading from '../../components/Loading'

const INITIAL_STATE = {
    loaded: false,
    data: null,
    error: null
}

function SharesOutstandingStats({ securityId }) {
    const [sharesDilution, setSharesDilution] = useState(INITIAL_STATE)

    const loadSharesDilution = useCallback(async () => {
        try {
            const data = await getSharesDilution({ page: 1, pageSize: 5, secId: securityId })
            setSharesDilution({ loaded: true, error: null, data: data[0] })
        } catch (err) {
            console.error(err)
            setSharesDilution(prev => ({
                ...prev,
                loaded: false,
                error: 'Something went wrong, please try again.'
            }))
        }
    }, [securityId])

    useEffect(() => {
        loadSharesDilution()
    }, [loadSharesDilution])

    const d = sharesDilution.data

    return (
        <div className={classNames(styles.CompanyQuoteSecurity)}>
            <Flex w={1} className={styles.summaryStats}>
                <Box w={1}><h4>Shares Outstanding Summary Level Statistics</h4></Box>
            </Flex>
            <Loading
                height='5em'
                loaded={sharesDilution.loaded}
                reloading={sharesDilution.reloading}
                error={sharesDilution.error}
            >
                <Flex wrap className={styles.statInfo}>
                    {[
                        { label: '3 Month Change', nominal: d?.nominalChange3Month, percent: d?.percentChange3Month },
                        { label: '6 Month Change', nominal: d?.nominalChange6Month, percent: d?.percentChange6Month },
                        { label: '12 Month Change', nominal: d?.nominalChange12Month, percent: d?.percentChange12Month }
                    ].map(({ label, nominal, percent }) => (
                        <Box key={label} w={[1 / 2, 1 / 3, 1 / 3]} className={styles.statInfoItem}>
                            <label>{label}</label>
                            <p>
                                <Locale type='int'>{nominal}</Locale>&nbsp;
                                {percent !== null && percent !== undefined && (
                                    <>(<Locale type='convertPercentage'>{percent}</Locale>)</>
                                )}
                            </p>
                        </Box>
                    ))}
                </Flex>
            </Loading>
        </div>
    )
}

SharesOutstandingStats.propTypes = {
    securityId: PropTypes.number
}

export default SharesOutstandingStats